<template>
  <div class="s-tabs">
    <router-link class="s-tab" :to="{ name: 'WebPartnerMarketingIndex' }"
      :class="{ 'active-tab': ($route.name === 'WebPartnerMarketingIndex') }">
      合作品牌點數交換
    </router-link>
    <router-link class="s-tab" :to="{ name: 'WebPartnerMarketingLogs' }"
      :class="{ 'active-tab': ($route.name === 'WebPartnerMarketingLogs') }">
      兌換紀錄查詢
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'PartnerMarketingTabs'
}
</script>

<style lang="scss" scoped>
.s-tabs {
  display: flex;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 10;
  justify-content: space-evenly;

  .s-tab {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    color: #999999 !important;
    text-decoration: none;
    flex: 1;

    &.active-tab {
      border-bottom: 4px solid #FE577F;
      color: #FE577F !important;
    }
  }
}
</style>